module.exports = __webpack_public_path__ + "assets/plus.88a288cc.svg";